import { render } from "./WhyInvest.vue?vue&type=template&id=35923741&scoped=true"
import script from "./WhyInvest.vue?vue&type=script&lang=js"
export * from "./WhyInvest.vue?vue&type=script&lang=js"

import "./WhyInvest.vue?vue&type=style&index=0&id=35923741&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35923741"]])

export default __exports__